import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Backdrop, Box, Button,
  Chip,
  CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
  FormControlLabel,
  IconButton,
  Switch,
  Table, TableBody,
  TableCell,
  TableContainer,
  TableHead, TablePagination,
  TableRow,
} from "@mui/material";

import {
  ArrowDropDownOutlined, MoreVertOutlined,
} from "@mui/icons-material";


import axios from "axios";
import moment from "moment";
import cookie from "react-cookies";
import { RECEIVER_COOKIE_KEY } from "../constant";
import { changeImageURL, getRecvCenterName, getShopNameString, getWarehouseName } from "../stringutils";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import DateRangePicker from "react-date-range/dist/components/DateRangePicker";
import { ko } from "react-date-range/dist/locale";
import { createStaticRanges } from "react-date-range";


import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
  // differenceInCalendarDays,
} from 'date-fns';
import { FSBarcodeReader } from "./FSBarcodeReader";
import { useSnackbar } from "notistack";
import { useWarehouseState } from "../WarehouseContext";
import { arrivalHistoryList, purchaseInfoForDialog } from "../common";


const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
};


const defaultStaticRanges = createStaticRanges([
  {
    label: '오늘',
    range: () => ({
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: '어제',
    range: () => ({
      startDate: defineds.startOfYesterday,
      endDate: defineds.endOfYesterday,
    }),
  },
  {
    label: '이번주',
    range: () => ({
      startDate: defineds.startOfWeek,
      endDate: defineds.endOfWeek,
    }),
  },
  {
    label: '지난주',
    range: () => ({
      startDate: defineds.startOfLastWeek,
      endDate: defineds.endOfLastWeek,
    }),
  },
  {
    label: '이번달',
    range: () => ({
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth,
    }),
  },
  {
    label: '지난달',
    range: () => ({
      startDate: defineds.startOfLastMonth,
      endDate: defineds.endOfLastMonth,
    }),
  },
]);


export default function ArrivalHistoryView(props) {
  const warehouseState = useWarehouseState()
  const history = useHistory()
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [dialog, setDialog] = useState({
    open: false,
    message: '',
    errorMessage: '',
  })

  const [selectedPurchase, setSelectedPurchase] = useState(null)

  const [requesting, setRequesting] = useState(false)
  const [showOverlayProgress, setShowOverlayProgress] = useState(false)
  const [arrivalList, setArrivalList] = useState([])
  const [message, setMessage] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [arrivalHistoryDialog, setArrivalHistoryDialog] = useState({
    open: false,
    history: [],
    purchase: null,
  })

  // const [filterDate, setFilterDate] = useState({
  //   startDate: defineds.startOfToday,
  //   endDate: defineds.endOfToday,
  //   key: 'selection'
  // })
  //
  const [filterDate, setFilterDate] = useState(() => {
    let lastStartDate = localStorage.getItem('lastStartDateFilter')
    let lastEndDate = localStorage.getItem('lastEndDateFilter')
    console.log('init date start date : ' + lastStartDate + ', end date : ' + lastEndDate)
    if (Boolean(lastStartDate) && Boolean(lastEndDate)) {
      console.log('restore date ' + new Date(lastStartDate) + ' ' + new Date(lastEndDate))
      return {
        startDate: new Date(lastStartDate),
        endDate: new Date(lastEndDate),
      }
    }
    return {
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    }
  })

  // const [snackbar, setSnackbar] = useState({
  //   open : false,
  //   message : '',
  // })
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [dateFilterName, setDateFilterName] = useState(() => {
    let name = localStorage.getItem('lastDateFilterName')
    if (Boolean(name)) {
      return name
    }
    return '오늘'
  })

  const [selectedDate, setSelectedDate] = useState([{
    startDate: defineds.startOfToday,
    endDate: defineds.endOfToday,
    key: 'selection'
  }])

  const [openSelectDate, setOpenSelectDate] = useState(false)
  const [imageShow, setImageShow] = useState({
    open: false,
    url: '',
    title: ''
  })
  const [showUnreceivedMode, setShowUnreceivedMode] = useState(false)

  // const [openFilterProducts , setOpenFilterProduct] = useState(false)
  // const [filterProducts, setFilterProducts] = useState([])

  // useEffect(() => {
  //
  //   requestArrival()
  //
  //   return () => {
  //     console.log('useEffect cleanup')
  //   }
  // }, [])

  const requestArrival = () => {

    // Server fetch only by date range; client-side filtering will be applied when rendering
    setPage(0);
    setRequesting(true)
    setMessage("")

    axios.get(`${process.env.REACT_APP_API_HOST}/arrival`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        startDate: moment(filterDate.startDate).format('YYYY/MM/DD'),
        endDate: moment(filterDate.endDate).format('YYYY/MM/DD'),
        id: null,
      },
    }).then((resp) => {
      console.log(resp.data)

      if (resp.status === 200 &&
        resp.data != null &&
        resp.data['code'] === 200) {

        if (resp.data['results'].length > 0) {
          // let test = []
          // for (let i = 0 ; i < 100; i++){
          //   test = test.concat(resp.data['results'])
          // }
          const results = resp.data['results']
          setArrivalList(results)

          // Build scoped options for ProductSearchBar when in history view
          try {
            const mapKey = (r) => r.product_fs_id || `${(r.product_name||'').toLowerCase()}|${r.product_opt_code||''}`
            const seen = new Set()
            const scopedOptions = []
            results.forEach(r => {
              const key = mapKey(r)
              if (key && !seen.has(key)) {
                seen.add(key)
                scopedOptions.push({
                  id: r.product_id,
                  opt_code: r.product_opt_code,
                  id_fs: r.product_fs_id,
                  name: r.product_name,
                  gsheet_rack_code: r.gsheet_rack_code,
                })
              }
            })
            if (props.onUpdateSearchScope) {
              props.onUpdateSearchScope(scopedOptions)
            }
          } catch (e) {
            console.warn('Failed to build scoped options', e)
            if (props.onUpdateSearchScope) {
              props.onUpdateSearchScope([])
            }
          }
        } else {
          setMessage("입고된 상품이 없습니다.")
          if (props.onUpdateSearchScope) {
            props.onUpdateSearchScope([])
          }
        }
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else {
        setDialog({
          open: true,
          message: "입고 데이터를 불러오는데 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
        if (props.onUpdateSearchScope) {
          props.onUpdateSearchScope([])
        }
      }

      setRequesting(false)

    }).catch((e) => {
      console.log('error : ' + e);

      setRequesting(false)
      setDialog({
        open: true,
        message: "입고 데이터를 불러오는데 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })
      if (props.onUpdateSearchScope) {
        props.onUpdateSearchScope([])
      }
    });
  }

  const requestUnreceivedProducts = () => {

    setPage(0)
    setRequesting(true)
    setMessage("")

    axios.get(`${process.env.REACT_APP_API_HOST}/arrival/unreceivedProducts`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        startDate: moment(filterDate.startDate).format('YYYY/MM/DD'),
        endDate: moment(filterDate.endDate).format('YYYY/MM/DD'),
        id: null,
      },
    }).then((resp) => {
      console.log(resp.data)

      if (resp.status === 200 &&
        resp.data != null &&
        resp.data['code'] === 200) {

        if (resp.data['results'].length > 0) {
          const results = resp.data['results']
          setArrivalList(results)

          try {
            const mapKey = (r) => r.product_fs_id || `${(r.product_name||'').toLowerCase()}|${r.product_opt_code||''}`
            const seen = new Set()
            const scopedOptions = []
            results.forEach(r => {
              const key = mapKey(r)
              if (key && !seen.has(key)) {
                seen.add(key)
                scopedOptions.push({
                  id: r.product_id,
                  opt_code: r.product_opt_code,
                  id_fs: r.product_fs_id,
                  name: r.product_name,
                  gsheet_rack_code: r.gsheet_rack_code,
                })
              }
            })
            if (props.onUpdateSearchScope) {
              props.onUpdateSearchScope(scopedOptions)
            }
          } catch (e) {
            console.warn('Failed to build scoped options', e)
            if (props.onUpdateSearchScope) {
              props.onUpdateSearchScope([])
            }
          }
        } else {
          setMessage("미입고 상품이 없습니다.")
          if (props.onUpdateSearchScope) {
            props.onUpdateSearchScope([])
          }
        }
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else {
        setDialog({
          open: true,
          message: "미입고 데이터를 불러오는데 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
        if (props.onUpdateSearchScope) {
          props.onUpdateSearchScope([])
        }
      }

      setRequesting(false)

    }).catch((e) => {
      console.log('error : ' + e)

      setRequesting(false)
      setDialog({
        open: true,
        message: "미입고 데이터를 불러오는데 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })
      if (props.onUpdateSearchScope) {
        props.onUpdateSearchScope([])
      }
    })
  }

  const requestCancelArrival = (selectedPurchase) => {
    setRequesting(true)
    setMessage("")
    setOpenDeleteDialog(false)

    console.log('requestCancelArrival', selectedPurchase)

    axios.post(`${process.env.REACT_APP_API_HOST}/arrival/cancel`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY)
      },
      center_id: selectedPurchase.recv_center,
      cart_no: selectedPurchase.cart_no,
      purchase_id: selectedPurchase.purchase_id,
      ff_yn: selectedPurchase.ff_yn,
      store_no: selectedPurchase.store_no,
      warehouse: selectedPurchase.warehouse
    }).then((resp) => {

      if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        // history.replace('/', {snackbar: '입고 취소가 완료되었습니다.'})
        // setSnackbar({
        //   open : true,
        //   message : '입고 취소가 완료되었습니다.'
        // })
        enqueueSnackbar(`"${selectedPurchase.product_name}" - 입고가 취소 되었습니다.`, { variant: 'success' })

        requestArrival()
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 461) {
        setDialog({
          open: true,
          message: "정상적인 경로로 입고 처리 되지 않아 취소가 불가능합니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
        setRequesting(false)
      } else {
        setDialog({
          open: true,
          message: "입고 취소를 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
        setRequesting(false)
      }

    }).catch((e) => {

      setDialog({
        open: true,
        message: "입고 취소를 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })

      setRequesting(false)
    })
  }

  const changeDateFilter = (date) => {
    let startDate = date[0].startDate
    let endDate = date[0].endDate

    // console.log(date[0].startDate, date[0].endDate)

    if (isSameDay(startDate, defineds.startOfToday) && isSameDay(endDate, defineds.endOfToday)) {
      setDateFilterName("오늘")
    } else if (isSameDay(startDate, defineds.startOfYesterday)
      && isSameDay(endDate, defineds.endOfYesterday)) {
      setDateFilterName("어제")
    } else if (isSameDay(startDate, defineds.startOfWeek)
      && isSameDay(endDate, defineds.endOfWeek)) {
      setDateFilterName("이번주")
    } else if (isSameDay(startDate, defineds.startOfLastWeek)
      && isSameDay(endDate, defineds.endOfLastWeek)) {
      setDateFilterName("지난주")
    } else if (isSameDay(startDate, defineds.startOfMonth)
      && isSameDay(endDate, defineds.endOfMonth)) {
      setDateFilterName("이번달")
    } else if (isSameDay(startDate, defineds.startOfLastMonth)
      && isSameDay(endDate, defineds.endOfLastMonth)) {
      setDateFilterName("지난달")
    } else {
      setDateFilterName(moment(startDate).format('YYYY/MM/DD') + "~" + moment(endDate).format('YYYY/MM/DD'))
    }

    setFilterDate(date[0])

  }

  useEffect(() => {
    console.log('useEffect fetch by date only, showUnreceivedMode:', showUnreceivedMode)
    if (showUnreceivedMode) {
      requestUnreceivedProducts()
    } else {
      requestArrival()
    }
  }, [filterDate, showUnreceivedMode])

  useEffect(() => {
    console.log('save filter ' + filterDate.startDate + ' ' + filterDate.endDate + ' ' + dateFilterName)
    localStorage.setItem(`lastStartDateFilter`, filterDate.startDate)
    localStorage.setItem(`lastEndDateFilter`, filterDate.endDate)
    localStorage.setItem(`lastDateFilterName`, dateFilterName)
  }, [filterDate])

  // When product filters change, ensure pagination resets to the first page
  useEffect(() => {
    setPage(0)
  }, [props.products])


  const getArrivalHistoryAndShowDialog = (purchase) => {
    setShowOverlayProgress(true)
    axios.get(`${process.env.REACT_APP_API_HOST}/arrival/history`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        purchase_id: purchase.purchase_id,
      },

    }).then((resp) => {

      if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        setArrivalHistoryDialog({
          open: true,
          history: resp.data.results,
          purchase: purchase
        })

        setShowOverlayProgress(false)
        return
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 451) {
        setDialog({
          open: true,
          title: "오류발생",
          message: "입고 처리 권한이 없는 계정입니다.",
          errorMessage: ''
        })
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else {
        setDialog({
          open: true,
          title: "오류발생",
          message: "서버와의 통신에 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
      }

      setShowOverlayProgress(false)

    }).catch((e) => {
      console.log('error ' + e)
      setDialog({
        open: true,
        title: "오류발생",
        message: "서버와의 통신에 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })

      setShowOverlayProgress(false)
    })
  }

  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <FSBarcodeReader
        onRequestStart={() => setRequesting(true)}
        onRequestResults={(results, barcode) => {
          if (results.length > 0) {
            console.log(results[0]['id_fs']);
            props.onSelected(results[0])
          } else {
            props.onNewBarcode(barcode)
          }
          setRequesting(false)
        }}
        onRequestError={(error) => {
          // setSnackbar({
          //   open : true,
          //   message : "바코드인식에 실패 하였습니다. (" + error + ")",
          // })
          enqueueSnackbar(`"바코드인식에 실패 하였습니다`, { variant: 'error' })

          setRequesting(false)
        }}
      />
      <Box sx={{
        paddingTop: (theme) => theme.spacing(0.5),
        width: "100%",
      }}>
        {
          requesting ?
            <Box sx={{
              marginTop: (theme) => theme.spacing(18),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <CircularProgress size={34} thickness={4} />
            </Box>
            :
            <React.Fragment>
              <Box sx={{
                paddingBottom: (theme) => theme.spacing(2),
                alignItems: 'center',
                display: 'flex',
                flexBasis: 1,
                flexDirection: 'row',
              }}>
                <Button
                  sx={{
                    height: 50, minWidth: 80
                  }}
                  aria-multiline={false}
                  onClick={() => {
                    setOpenSelectDate(true)
                  }}
                  color={'neutral'}
                  variant={"outlined"}
                  endIcon={<ArrowDropDownOutlined />}
                >
                  {dateFilterName}
                </Button>
                {showUnreceivedMode && (
                  <Chip
                    label="미입고 상품"
                    color="secondary"
                    size="small"
                    sx={{ ml: 1 }}
                  />
                )}
                <div style={{ flexGrow: 1 }}>
                  <Box sx={{
                    display: 'flex',
                    justifyItems: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}>
                    {
                      props.products != null && props.products.length > 0 ?
                        props.products.map((filter) => (
                          <Chip
                            sx={{ marginLeft: (theme) => theme.spacing(1.0), }}
                            label={filter.name}
                            onDelete={() => {
                              props.onDeleteFilter(filter)
                              // setFilterProducts(filterProducts.filter((f) => filter.id !== f.id))
                            }}
                          />
                        ))
                        :
                        <div />
                    }
                  </Box>
                </div>

              </Box>
              {
                Boolean(message) ?
                  <Box sx={{
                    marginTop: (theme) => theme.spacing(18),
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}>
                    <p>{message}</p>
                  </Box>
                  :
                  <React.Fragment>
                    <Divider />
                    <TableContainer>
                      <Table>
                        <TableHead sx={{ width: '100%' }}>
                          <TableRow>
                            <TableCell>상품명</TableCell>

                            <TableCell align="left">주문날짜</TableCell>
                            <TableCell align="left">주문처</TableCell>
                            <TableCell align="left">배송지</TableCell>
                            <TableCell align="left">주문</TableCell>
                            <TableCell align="left">갯수</TableCell>

                            <TableCell align="left">위치</TableCell>
                            {/*<TableCell align="right">옵션</TableCell>*/}
                            {/*<TableCell align="right">위치</TableCell>*/}
                            {!showUnreceivedMode && <TableCell align="left">유통기한</TableCell>}
                            {!showUnreceivedMode && <TableCell align="left">입고위치</TableCell>}
                            {!showUnreceivedMode && <TableCell align="left">작업자</TableCell>}
                            {!showUnreceivedMode && <TableCell align="left">입고날짜</TableCell>}
                            {!showUnreceivedMode && <TableCell align="right"></TableCell>}
                            <TableCell align="right"></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{ width: '100%' }}>
                          {(props.products && props.products.length > 0
                              ? (() => {
                                  const idSet = new Set(props.products.map(p => p.id_fs).filter(Boolean));
                                  const nameList = props.products.map(p => (p.name || '')).filter(Boolean);
                                  return arrivalList.filter(row => {
                                    // Prefer product_fs_id match when available
                                    if (row.product_fs_id && idSet.size > 0) {
                                      return idSet.has(row.product_fs_id);
                                    }
                                    // Fallback to product name contains any selected name
                                    if (nameList.length > 0 && row.product_name) {
                                      const lower = row.product_name.toLowerCase();
                                      return nameList.some(n => lower.includes(n.toLowerCase()));
                                    }
                                    return true;
                                  });
                                })()
                              : arrivalList)
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => (
                              <TableRow
                                key={index}
                              >
                                <TableCell component="th" scope="row">
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {
                                      row.img_url ?
                                        <img
                                          onClick={() => {
                                            setImageShow({
                                              open: true,
                                              url: row.img_url,
                                              title: row.product_name
                                            })
                                          }}
                                          style={{
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: 48, height: 48
                                          }} src={changeImageURL(row.img_url)} alt={row.product_name} />
                                        :
                                        <div style={{ width: 48, height: 48 }} />
                                    }
                                    <div
                                      style={{ marginLeft: 6 }}>{row.product_name}</div>
                                  </div>
                                </TableCell>
                                <TableCell align={"left"} component="th" scope="row">
                                  {moment(new Date(row.order_date)).format('YYYY/MM/DD HH:mm')}
                                </TableCell>
                                <TableCell align={"left"} component="th" scope="row">
                                  {getShopNameString(row.shop_name)}
                                </TableCell>
                                <TableCell align={"left"} component="th" scope="row">
                                  {getWarehouseName(row.warehouse, warehouseState)}
                                </TableCell>
                                <TableCell align={"left"} component="th" scope="row">
                                  {row.buyer_name_list}</TableCell>
                                <TableCell align="left">{showUnreceivedMode ? row.buy_quantity : row.recv_quantity + '/' + row.buy_quantity}</TableCell>
                                <TableCell align="left">{row.gsheet_rack_code}</TableCell>
                                {!showUnreceivedMode && <TableCell align="left"> {row.expire_date ? moment(new Date(row.expire_date)).format('YYYY/MM') : '-'}</TableCell>}
                                {/*<TableCell align="right">{row.product_id + ' / ' + row.product_opt_code + ' / ' + row.gsheet_rack_code}</TableCell>*/}
                                {/*<TableCell align="right">{row.product_opt_code}</TableCell>*/}
                                {/*<TableCell align="right">{row.gsheet_rack_code}</TableCell>*/}
                                {!showUnreceivedMode && <TableCell align="left">{getRecvCenterName(row, warehouseState)}</TableCell>}
                                {!showUnreceivedMode && <TableCell align="left">{row.receiver_name}</TableCell>}
                                {!showUnreceivedMode && <TableCell align={"left"} component="th" scope="row">
                                  {moment(new Date(row.recv_date)).format('YYYY/MM/DD HH:mm')}
                                </TableCell>}
                                {!showUnreceivedMode && <TableCell align="right">
                                  {/*<ChevronRight/>*/}
                                  {
                                    row.recv_state !== 'W' ?
                                      <Button
                                        onClick={() => {

                                          setOpenDeleteDialog(true)
                                          setSelectedPurchase(row)


                                        }}
                                        variant={"contained"} color={"secondary"}>
                                        취소
                                      </Button>
                                      :
                                      <div />
                                  }
                                </TableCell>}
                                <TableCell align={"right"}>
                                  <IconButton
                                    onClick={() => {
                                      getArrivalHistoryAndShowDialog(row, null, false)
                                    }}>
                                    <MoreVertOutlined fontSize={'small'} />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[10, 15, 20]}
                      component="div"
                      count={(props.products && props.products.length > 0
                        ? (() => {
                            const idSet = new Set(props.products.map(p => p.id_fs).filter(Boolean));
                            const nameList = props.products.map(p => (p.name || '')).filter(Boolean);
                            return arrivalList.filter(row => {
                              if (row.product_fs_id && idSet.size > 0) return idSet.has(row.product_fs_id);
                              if (nameList.length > 0 && row.product_name) {
                                const lower = row.product_name.toLowerCase();
                                return nameList.some(n => lower.includes(n.toLowerCase()));
                              }
                              return true;
                            }).length;
                          })()
                        : arrivalList.length)}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={(event, newPage) => {
                        setPage(newPage)
                      }}
                      onRowsPerPageChange={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                      }}
                    />
                  </React.Fragment>

              }
            </React.Fragment>
        }
      </Box>
      <Dialog
        open={openDeleteDialog}
        onClose={() => { setOpenDeleteDialog(false) }}
      >

        <DialogContent aria-multiline={true}>
          <div>{"입고를 취소 하시겠습니까?"}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenDeleteDialog(false) }} color="secondary">
            아니요
          </Button>
          <Button onClick={() => { requestCancelArrival(selectedPurchase) }} color="primary">
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialog.open}
        onClose={() => {
          setDialog({ open: false, message: '', errorMessage: '' })
        }}
      >
        <DialogTitle id="alert-dialog-title">{"오류발생"}</DialogTitle>

        <DialogContent aria-multiline={true}>
          <div>{dialog.message}</div>
          <div>{dialog.errorMessage}</div>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setDialog({ open: false, message: '', errorMessage: '' }) }} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSelectDate}
        onClose={() => setOpenSelectDate(false)}
      >
        <DialogContent sx={{
          display: 'flex',
          flexDirection: 'column',
          width: 460,
          pb: 0,
        }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mb: 1,
          }}>
            <FormControlLabel
              control={
                <Switch
                  checked={showUnreceivedMode}
                  onChange={(e) => {
                    const next = e.target.checked
                    setShowUnreceivedMode(next)
                    if (!next) {
                      // 미입고 모드 해제 시 선택된 날짜를 오늘로 초기화
                      setSelectedDate([{
                        startDate: defineds.startOfToday,
                        endDate: defineds.endOfToday,
                        key: 'selection',
                      }])
                    }
                  }}
                  color="secondary"
                />
              }
              label="미입고 상품 보기(주문일자기준)"
              labelPlacement="start"
            />
          </Box>
          <DateRangePicker
            locale={ko}
            onChange={item => setSelectedDate([item.selection])}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            ranges={selectedDate}
            direction="horizontal"
            inputRanges={[]}
            staticRanges={defaultStaticRanges}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSelectDate(false)} color="primary">
            취소
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setOpenSelectDate(false)
              changeDateFilter(selectedDate)
            }}>
            적용
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        color: '#fff',
      }} open={imageShow.open} onClick={() => setImageShow({ ...imageShow, open: false })}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={changeImageURL(imageShow.url)} style={{ width: 320, height: 320 }} />
          <div style={{ marginTop: 10 }}>{imageShow.title}</div>
        </div>
      </Backdrop>
      <Dialog
        id={'check-arrival-dialog'}
        open={arrivalHistoryDialog.open}
        onClose={() => {
          setArrivalHistoryDialog({
            ...arrivalHistoryDialog,
            open: false,
          })
        }}
      >
        <DialogTitle>변경 내역</DialogTitle>

        <DialogContent>
          {purchaseInfoForDialog(arrivalHistoryDialog.purchase)}
        </DialogContent>
        <DialogContent
          aria-multiline={true}
          sx={{
            minWidth: 280,
            maxHeight: 240,
            p: 1,
            borderWidth: (theme) => theme.spacing(0.1),
            borderColor: 'black',
            borderStyle: 'solid',
          }}
        >
          {
            arrivalHistoryList(arrivalHistoryDialog.history, arrivalHistoryDialog.purchase)
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setArrivalHistoryDialog({ ...arrivalHistoryDialog, open: false })} color="secondary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        open={showOverlayProgress}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: '#fff',
        }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  )

}